module.exports = __webpack_public_path__ + "static/media/icon_arrow_up_2.47b8c4a2.svg";